import { template } from "@ember/template-compiler";
import Box from 'core/components/box';
import FlexGrid from 'core/components/flex-grid';
import Typography from 'core/components/typography';
export default template(`
  <div class="tier-card tier-size-card" ...attributes>
    <Box @padding="0 lg 0 lg">
      <FlexGrid as |G|>
        <G.Item @xs="6" @sm="6" @md="6" @lg="6">
          <Typography @variant="h4" data-test-name>
            {{@name}}
          </Typography>
        </G.Item>
        <G.Item @xs="6" @sm="6" @md="6" @lg="6">
          {{#if @cost}}
            <Typography
              @variant="h4"
              class="tier-size-card__cost"
              data-test-cost={{@name}}
            >
              {{@cost}}
            </Typography>
          {{/if}}
        </G.Item>
        <G.Item @xs="12" @sm="12" @md="12" @lg="12">
          {{yield}}
        </G.Item>
      </FlexGrid>
    </Box>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvcmVzb3VyY2UtY2F0YWxvZy9wYWNrYWdlL3NyYy9jb21wb25lbnRzL3Jlc291cmNlLWNhdGFsb2cvdGllci1zaXplLWNhcmQuZ2pzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBCb3ggZnJvbSAnY29yZS9jb21wb25lbnRzL2JveCc7XG5pbXBvcnQgRmxleEdyaWQgZnJvbSAnY29yZS9jb21wb25lbnRzL2ZsZXgtZ3JpZCc7XG5pbXBvcnQgVHlwb2dyYXBoeSBmcm9tICdjb3JlL2NvbXBvbmVudHMvdHlwb2dyYXBoeSc7XG5cbjx0ZW1wbGF0ZT5cbiAgPGRpdiBjbGFzcz1cInRpZXItY2FyZCB0aWVyLXNpemUtY2FyZFwiIC4uLmF0dHJpYnV0ZXM-XG4gICAgPEJveCBAcGFkZGluZz1cIjAgbGcgMCBsZ1wiPlxuICAgICAgPEZsZXhHcmlkIGFzIHxHfD5cbiAgICAgICAgPEcuSXRlbSBAeHM9XCI2XCIgQHNtPVwiNlwiIEBtZD1cIjZcIiBAbGc9XCI2XCI-XG4gICAgICAgICAgPFR5cG9ncmFwaHkgQHZhcmlhbnQ9XCJoNFwiIGRhdGEtdGVzdC1uYW1lPlxuICAgICAgICAgICAge3tAbmFtZX19XG4gICAgICAgICAgPC9UeXBvZ3JhcGh5PlxuICAgICAgICA8L0cuSXRlbT5cbiAgICAgICAgPEcuSXRlbSBAeHM9XCI2XCIgQHNtPVwiNlwiIEBtZD1cIjZcIiBAbGc9XCI2XCI-XG4gICAgICAgICAge3sjaWYgQGNvc3R9fVxuICAgICAgICAgICAgPFR5cG9ncmFwaHlcbiAgICAgICAgICAgICAgQHZhcmlhbnQ9XCJoNFwiXG4gICAgICAgICAgICAgIGNsYXNzPVwidGllci1zaXplLWNhcmRfX2Nvc3RcIlxuICAgICAgICAgICAgICBkYXRhLXRlc3QtY29zdD17e0BuYW1lfX1cbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAge3tAY29zdH19XG4gICAgICAgICAgICA8L1R5cG9ncmFwaHk-XG4gICAgICAgICAge3svaWZ9fVxuICAgICAgICA8L0cuSXRlbT5cbiAgICAgICAgPEcuSXRlbSBAeHM9XCIxMlwiIEBzbT1cIjEyXCIgQG1kPVwiMTJcIiBAbGc9XCIxMlwiPlxuICAgICAgICAgIHt7eWllbGR9fVxuICAgICAgICA8L0cuSXRlbT5cbiAgICAgIDwvRmxleEdyaWQ-XG4gICAgPC9Cb3g-XG4gIDwvZGl2PlxuPC90ZW1wbGF0ZT5cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxTQUFTLHNCQUFzQjtBQUN0QyxPQUFPLGNBQWMsNEJBQTRCO0FBQ2pELE9BQU8sZ0JBQWdCLDZCQUE2QjtBQUVwRCxlQUFBLFNBQVUsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUEwQlYsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBLEdBQUMifQ